<template>
  <div class="zhima-video">
    <HDFHeader03 />
    <div class="sel">
      <div class="row">
        <div class="name">课程类别</div>
        <div
          v-for="item in typeList"
          :key="item.code"
          class="btn"
          :class="curType === item.code ? 'active' : ''"
          @click="changeType(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="row">
        <div class="name">课程人群</div>
        <div
          v-for="item in groupList"
          :key="item.code"
          class="btn"
          :class="curGroup === item.code ? 'active' : ''"
          @click="changeGroup(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="row">
        <div class="name">会员课程</div>
        <div
          v-for="item in classList"
          :key="item.code"
          class="btn"
          :class="curClass === item.code ? 'active' : ''"
          @click="changeClass(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="video-list">
      <div class="card" v-for="(item, index) in videoList" :key="item.id" @click="toPage(index)">
        <img class="img" :src="item.img" />
        <div class="title1">{{ item.title1 }}</div>
        <div class="title2">{{ item.title2 }}</div>
        <div class="unbuy" v-if="!isBuy">
          <el-icon size="48"><Lock /></el-icon>
          <div class="title3">会员专享</div>
          <div class="title4">请购买智码单会员或升级联合会员后学习</div>
          <div class="btn-buy" @click="toBuy">前去购买</div>
        </div>
      </div>
    </div>
    <div>
      <!-- <HDFFooter /> -->
      <HDFCopyright />
    </div>
  </div>
</template>
<script setup>
// import HDFFooter from '@/components/HDFFooter.vue'
import HDFCopyright from '@/components/HDFCopyright.vue'
import { onBeforeMount, ref } from 'vue'
import HDFHeader03 from '@/components/HDFHeader03.vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const isBuy = ref(0)

onBeforeMount(() => {
  // TODO 请求数据, 判断是否购买
  // isBuy.value = true
  if (window.localStorage.getItem('token') === '13800000001') {
    isBuy.value = true
  } else if (window.localStorage.getItem('token') === '13800000002') {
    isBuy.value = true
  } else {
    isBuy.value = false
  }
})

const typeList = [
  {
    code: '001',
    name: 'Scratch'
  },
  {
    code: '002',
    name: '嵌入式开发'
  }
]
const curType = ref('001')
const changeType = ({ code }) => {
  curType.value = code
  // TODO 请求数据
}

const groupList = [
  {
    code: '003',
    name: '小学课程'
  },
  {
    code: '004',
    name: '初中课程'
  },
  {
    code: '005',
    name: '高中课程'
  }
]
const curGroup = ref('003')
const changeGroup = ({ code }) => {
  curGroup.value = code
  // TODO 请求数据
}
const classList = [
  {
    code: '006',
    name: '普适课程'
  },
  {
    code: '007',
    name: '针对性课程'
  }
]
const curClass = ref('006')
const changeClass = ({ code }) => {
  curClass.value = code
  // TODO 请求数据
}
const videoList = [
  {
    id: 'img-001',
    img: require('@/assets/images/score-imgs/score-img-1.jpg'),
    title1: '青少年人工智能技术水平测试',
    title2: '主要用于考察青少年在人工智能关键技术、产品、服务及应用方面的...'
  },
  {
    id: 'img-002',
    img: require('@/assets/images/score-imgs/score-img-2.jpg'),
    title1: 'Python编程入门与AI启蒙',
    title2: '专为零基础学员设计的入门课程，通过图形化工具与趣味游戏开发...'
  },
  {
    id: 'img-003',
    img: require('@/assets/images/score-imgs/score-img-3.jpg'),
    title1: '机器学习初探——智能决策训练营',
    title2: '借助Scikit-learn与图形化建模平台，从生活场...'
  },
  {
    id: 'img-004',
    img: require('@/assets/images/score-imgs/score-img-4.jpg'),
    title1: '计算机视觉魔法课堂',
    title2: '从图像数字化原理到前沿卷积神经网络，通过OpenCV...'
  },
  {
    id: 'img-005',
    img: require('@/assets/images/score-imgs/score-img-5.jpg'),
    title1: '自然语言处理工坊',
    title2: '聚焦中文语境下的NLP技术，从词向量构建到深度学习模...'
  },
  {
    id: 'img-006',
    img: require('@/assets/images/score-imgs/score-img-6.jpg'),
    title1: 'AI机器人设计与实践',
    title2: '融合硬件编程与AI算法，基于ROS机器人操作系统开发智能体。从...'
  },
  {
    id: 'img-007',
    img: require('@/assets/images/score-imgs/score-img-7.jpg'),
    title1: '数据分析与可视化大师课',
    title2: '以Python生态为核心，通过Pandas数据清洗、Matp...'
  },
  {
    id: 'img-008',
    img: require('@/assets/images/score-imgs/score-img-8.jpg'),
    title1: '深度学习神经网络解密',
    title2: '从手写数字识别到AI艺术创作，通过TensorFlow/Keras框...'
  },
  {
    id: 'img-009',
    img: require('@/assets/images/score-imgs/score-img-9.jpg'),
    title1: 'AI伦理与未来社会',
    title2: '通过无人驾驶电车难题、AI招聘性别偏见等经典案例，探讨...'
  },
  {
    id: 'img-010',
    img: require('@/assets/images/score-imgs/score-img-10.jpg'),
    title1: '智能硬件创客实验室',
    title2: '基于树莓派与Arduino开发平台，打造物联网与AI结合的创新项...'
  },
  {
    id: 'img-0011',
    img: require('@/assets/images/score-imgs/score-img-11.jpg'),
    title1: 'AI游戏开发特训营',
    title2: '使用Unity引擎与ML-Agents工具包，开发具有自主学习能...'
  },
  {
    id: 'img-0012',
    img: require('@/assets/images/score-imgs/score-img-12.jpg'),
    title1: 'AI创新项目孵化器',
    title2: '以联合国可持续发展目标为选题方向，指导学生团队完成...'
  }
]

const toBuy = () => {
  // TODO 跳转购买页面
  if (window.localStorage.getItem('token')) {
    router.push('/personalCenter')
  } else {
    router.push('/signIn')
  }
}

const toPage = (index) => {
  if (isBuy.value) {
    window.location.href='/zms?id='+index
  }
}

</script>
<style scoped>
.zhima-video {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.sel {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  width: 1080px;
}
.row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
.name {
  font-weight: 600;
  padding: 4px 8px;
}
.btn {
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}
.btn.active {
  background-color: #4ea8ff;
  color: #fff;
}
.video-list {
  width: 1080px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2vw 2vh;
}
.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  flex-grow: 0;
  text-align: left;
  position: relative;
  cursor: pointer;
}
.img {
  width: 100%;
  flex-grow: 0;
}
.card .title1{
  font-size: 14px;
}
.card .title2{
  font-size: 12px;
  color: #545454;
}
.unbuy {
  position: absolute;
  background-color: #000a;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: #fff;
}
.btn-buy {
  background-color: #336FFF;
  color: #fff;
  width: 80px;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
